import React from "react";

import Richtext from "../Richtext";

import type { PdfCoverData, PdfLegalOwnerAndContributors } from "./types.d";

type PdfCoverProps = {
  print?: PdfCoverData | null;
  isNormen?: boolean;
  breakPage?: boolean;
  legalOwnerAndContributors?: PdfLegalOwnerAndContributors;
  lang?: Record<string, string>;
};

export default function PdfCover(props: Readonly<PdfCoverProps>) {
  const {
    print,
    breakPage,
    legalOwnerAndContributors,
    lang
  } = props;

  if (!print) {
    return null;
  }

  const publisherNameList = [
    ...(legalOwnerAndContributors?.legalOwner ?? []),
    ...(legalOwnerAndContributors?.contributors ?? [])
  ]
    .map((publisherEntry) => publisherEntry.name)
    .filter(Boolean);
  const publisherNames = publisherNameList.length > 1
    ? `${publisherNameList.slice(0, -1).join(", ")} og ${publisherNameList[publisherNameList.length - 1]}`
    : publisherNameList.join("");
  const lastlyProfessionally = lang?.["string.lastlyProfessionally"];
  const firstPublished = lang?.["string.firstPublished"];
  const publisher = lang?.["string.publisher"];

  return (
    <div
      className={`cover-page${breakPage ? " print-page-break" : ""}`}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "22.7cm",
        maxHeight: "22.7cm"
      }}
    >
      <table className="cover-table" style={{ width: "100%", marginTop: "40px" }}>
        <tbody>
          <tr>
            <td width="100%" className="cover-left">
              {print.title && <h1>{print.title}</h1>}
              <br />
              {print.typeCapitalized && (
                <p style={{ marginBottom: "10px" }}>{print.typeCapitalized}</p>
              )}
              <p>
                {publisherNames && (
                  <>
                    <span>{`${publisher ?? ""}: ${publisherNames}`}</span>
                    <br />
                  </>
                )}
                {print.firstPublish && <span>{`${firstPublished ?? ""}: ${print.firstPublish}`}</span>}
                <br />
                {print.lastChanged && (
                  <span>{`${lastlyProfessionally ?? ""}: ${print.lastChanged}`}</span>
                )}
              </p>
            </td>
          </tr>
        </tbody>
      </table>

      {print.refText && (
        <div className="cover-reference" style={{ maxWidth: "11cm" }}>
          <p className="cover-reference__label">Slik siterer du:</p>
          <Richtext text={print.refText} />
        </div>
      )}
    </div>
  );
}
